import { SxProps, Theme } from '@mui/material/styles';
import { FC, memo } from 'react';

import GenericLayout from '../../components/generic-layout/GenericLayout';
import Grid2 from '../../components/grid/Grid2';
import { H2 } from '../../components/heading/Hx';
import Img from '../../components/img/Img';
import Paragraph from '../../components/paragraph/Paragraph';
import Route from '../../components/route/Route';
import { RoutePath } from '../../components/route/type';
import NoPageImageSection from '../../components/section/NoPageImageSection';
import { COLOR } from '../../theme/type';

const SX_IMG: SxProps<Theme> = {
  borderRadius: '0.25rem',
  lineHeight: '1.25rem',
  marginBottom: '0.25rem',
  maxWidth: '500px',
  width: '100%',
};

const SolovevStyle: FC = () => (
  <GenericLayout title='Solovev Defense'>
    <NoPageImageSection background={COLOR.Dark3}>
      <H2 color={COLOR.Gold1}>Solovev Style, Solovev Defense oder Systema Solovev</H2>

      <Grid2 spacing='2rem'>
        <Grid2.Item>
          <Paragraph margin='0'>
            Solovev Style hat seinen Ursprung bei{' '}
            <Route href={RoutePath.AlexanderSolovev}>Alexander Solovev</Route>, der in Barnaul in
            Russland lebt. Alexander hatte verschiedene Lehrer und setzte seinen Stil daraus
            zusammen.
          </Paragraph>
          <Paragraph>
            Solovev Style wird heute vor allem in Russland unterrichtet. Wichtige Schulen sind in
            Barnaul (Alexander Solovev) und St. Petersburg (Sergey Tiunin). In Europa wird der Stil
            von <Route href={RoutePath.FalkoZander}>Falko Zander</Route> vertreten.
          </Paragraph>
          <Paragraph>
            Dieser Systema Stil setzt sehr stark auf seine absolute Weichheit und Präzision. Die
            wichtigsten Prinzipien sind Beladen, Überspielen, Kontinuität und Kontakt. Darüber
            hinaus wird permanent darauf geachtet, alles mit Hingabe und Genuss auszuführen.
          </Paragraph>
          <Paragraph>
            Alexander Solovev ist berühmt für seine feine, weiche Arbeit in Verbindung mit der
            unglaublichen Härte und Dynamik die daraus entstehen kann. Im Zentrum des Trainings
            steht deshalb langsames und präzises Arbeiten.
          </Paragraph>
          <Paragraph>
            Leider ist Solovev Style sehr schwer zu unterrichten und zu erlernen, weshalb es derzeit
            weltweit nur drei aktive Meister gibt: Alexander Solovev, Sergey Tiunin und Falko
            Zander.
          </Paragraph>
          <Paragraph>
            Um mehr Schülern die Chance zu geben die Meisterschaft zu erreichen, hat Falko Zander
            seine Erfahrungen aus hunderten Stunden Privatunterricht mit Alexander Solovev in ein{' '}
            <Route href={RoutePath.KampfkunstRanking}>Graduierung-System</Route> gesteckt. Damit
            können seine Schüler seinem Beispiel folgen und Meister werden. Auch wenn der Stil damit
            vom freien Unterrichtsstil von Systema abweicht, sind die Prinzipien dennoch die
            gleichen. Um seinen Lehrer und die enge Verbindung zu ihm zu ehren, behielt Falko Zander
            den Namen bei und nannte sein System{' '}
            <strong style={{ textTransform: 'uppercase' }}>"Solovev Defense"</strong>.
          </Paragraph>
          <Paragraph>
            Alexander Solovev erkennt das Graduierung-System an und ist einziger Großmeister mit dem
            8. Großmeistergrad. Am 05.04.2022 hat er Falko Zander den 5. Meistergrad verliehen.
          </Paragraph>
        </Grid2.Item>
        <Grid2.Centered>
          <Img
            alt='Alexander Solovev verleiht Falko Zander den 3. Meistergrad, Berlin 2018'
            src='/img/img-alexander-solovev-falko-zander-3rd-degree.jpg'
            sx={{ ...SX_IMG, marginTop: '0.25rem' }}
          />
          <Paragraph margin='0' variant='body2'>
            Alexander Solovev verleiht Falko Zander den 3. Meistergrad, Berlin 2018
          </Paragraph>

          <Img
            alt='Alexander Solovev, Manfred Steiner und Falko Zander in Berlin, 2018'
            src='/img/img-alexander-solovev-manfred-steiner-falko-zander.jpg'
            sx={{ ...SX_IMG, marginTop: '1rem' }}
          />
          <Paragraph margin='0' variant='body2'>
            Alexander Solovev, Manfred Steiner und Falko Zander in Berlin, 2018
          </Paragraph>
        </Grid2.Centered>
      </Grid2>
    </NoPageImageSection>
  </GenericLayout>
);

export default memo(SolovevStyle);
